'use client';
import { createTheme } from '@mui/material/styles';
import { PRIMARY_COLOR } from './LayoutConstants';

const theme = createTheme({
  typography: {
    fontFamily: 'var(--font-main)',
    fontWeightBold: '600',
  },
  palette: {
    primary: {
      main: PRIMARY_COLOR,
    }
  }
});

export default theme;